import { useIntl } from "react-intl";
import { useToast } from "@packsize/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { closeManually } from "@/api/production-api";

import { CLOSING_REQUIRED_JOBS_QUERY_KEY } from "./use-closing-required-cartons";
import { CLOSING_FAILED_JOBS_QUERY_KEY } from "./use-closing-failed-jobs";

export const useCloseManually = (packagingSolutionId: string, closingId: string) => {
	const intl = useIntl();
	const { toastSuccess, toastError } = useToast();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: () => {
			return closeManually(packagingSolutionId, closingId);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CLOSING_REQUIRED_JOBS_QUERY_KEY] });
			queryClient.invalidateQueries({ queryKey: [CLOSING_FAILED_JOBS_QUERY_KEY] });
			toastSuccess({
				message: intl.formatMessage({ id: "Manually close successful", defaultMessage: "Manually close successful" }),
			});
		},
		onError: (error: unknown) => {
			console.error("Failed to close manually", error);
			const errorReason =
				(error as { response?: { data?: { errorReason?: string } } })?.response?.data?.errorReason || "Unknown error";
			toastError({
				message: intl.formatMessage(
					{ id: "Failed to close manually: {errorReason}", defaultMessage: "Failed to close manually: {errorReason}" },
					{ errorReason },
				),
			});
		},
	});

	return {
		close: () => mutation.mutate(),
		isClosing: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
	};
};
